export default [ 'en', 'th', 'pl', 'fr', 'km' ]

// export default [ 'en', 'pt', 'th', 'de', 'es', 'fr' ]